// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.board-item-details-left-info-container {
  padding: 0 1rem;
  font-size: 0.875rem;
}

.board-item-details-left-info {
  display: flex;
  justify-content: space-between;
}

.board-item-details-right-box {
  display: flex;
  flex-direction: column;
  flex: 0.5;
}

.board-item-details-select-text {
  font-size: 0.875rem;
}

.board-item-trip-created {
  display: flex;
  justify-content: flex-end;
  gap: 0.2rem;
  font-size: 0.8rem;
  color: green;
}

.board-item-details-actions {
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem; */
  flex: 1;
}

.board-item-details-select-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.board-item-details-created-top-box {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.board-item-details-created-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 0;
}

.board-item-created-scrollable-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.board-item-accept-reject-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 12px;
  padding: 0.75rem 1.5rem;
  border-top: 1px solid #f0f0f0;
  background: #fff;
  z-index: 2;
}

.board-item-details-buttons-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}

.board-item-btns-1 {
  width: 50% !important;
  background-color: #fff !important;
  border: 1px solid #0b0b0b !important;
  color: #333 !important;
}

.board-item-btns-2 {
  width: 50% !important;
}

.board-item-trips-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f5f5f5;
  font-size: 0.9rem;
}

.board-item-trips-accordion {
  box-shadow: none !important;
  background-color: transparent !important;
}

.board-item-trip {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.board-item-trip-item {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #ccc;
  font-size: 0.8rem;
}

.board-item-trip-radio-label {
  font-size: 0.8rem;
}

.board-item-trip-radio-label-trip-id {
  font-weight: bold;
}

.board-item-trip-type-radio {
  font-size: 0.8rem;
}

.soft-select__menu-portal {
  z-index: 10001 !important;
}

.ods-table {
  width: 100%;
  font-size: 0.875rem;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2); */
  display: table;
}

@media screen and (max-width: 580px) {
  .ods-table {
    display: block;
  }
}

.ods-table-row {
  display: table-row;
  background: #fff;
}

.ods-table-row:nth-of-type(odd) {
  background: #f5f5f5;
}

.ods-table-row.header {
  font-weight: 600;
  /* color: #ffffff; */
  /* background: var(--blue); */
}

@media screen and (max-width: 580px) {
  .ods-table-row {
    padding: 14px 0 7px;
    display: block;
  }

  .ods-table-row.header {
    padding: 0;
    height: 6px;
  }

  .ods-table-row.header .ods-table-cell {
    display: none;
  }

  .ods-table-row .ods-table-cell {
    margin-bottom: 10px;
  }

  .ods-table-row .ods-table-cell:before {
    margin-bottom: 3px;
    content: attr(data-title);
    min-width: 98px;
    font-size: 0.625rem;
    line-height: 10px;
    font-weight: bold;
    text-transform: uppercase;
    color: #969696;
    display: block;
  }
}

.ods-table-cell {
  padding: 6px 4px;
  display: table-cell;
}

@media screen and (max-width: 580px) {
  .ods-table-cell {
    padding: 2px 16px;
    display: block;
  }

  .ods-table-footer {
    display: none;
  }
}

.ods-table-footer {
  padding: 6px 12px;
  border: none !important;
  font-weight: 700;
  font-size: 1.125rem;
  background-color: #f5f5f5;
}

.single-page-open-box {
  flex: 1;
}

.ods-board-item-channel-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.688rem;
  font-weight: 600;
  border: 1px solid;
  text-transform: capitalize;
  transition: all 0.2s ease;
}

.ods-board-item-channel-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Hover effect for the badge */
.ods-board-item-channel-badge:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ods-board-sales-channel {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  font-size: 0.813rem;
  font-weight: 700;
}

.ods-board-delivery-agent {
  font-weight: 500;
  font-size: 0.813rem;
  color: #6c7289;
}

.ods-board-agent-name {
  font-weight: 700;
  font-size: 0.813rem;
  color: #5b6072;
}

/* ── Dark theme ── */
.dark .board-item-accept-reject-section {
  background: #0f172a;
  border-top-color: #334155;
}

.dark .board-item-btns-1 {
  background-color: #1e293b !important;
  border-color: #475569 !important;
  color: #f1f5f9 !important;
}

.dark .board-item-trips-container {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .board-item-trip-item {
  background-color: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .ods-table-row {
  background: #1e293b;
  color: #f1f5f9;
}

.dark .ods-table-row:nth-of-type(odd) {
  background: #0f172a;
}

.dark .ods-table-footer {
  background-color: #1e293b;
  color: #f1f5f9;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/BoardItemActions.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;;;;cAIY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".board-item-details-left-info-container {\n  padding: 0 1rem;\n  font-size: 0.875rem;\n}\n\n.board-item-details-left-info {\n  display: flex;\n  justify-content: space-between;\n}\n\n.board-item-details-right-box {\n  display: flex;\n  flex-direction: column;\n  flex: 0.5;\n}\n\n.board-item-details-select-text {\n  font-size: 0.875rem;\n}\n\n.board-item-trip-created {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.2rem;\n  font-size: 0.8rem;\n  color: green;\n}\n\n.board-item-details-actions {\n  /* display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem; */\n  flex: 1;\n}\n\n.board-item-details-select-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.board-item-details-created-top-box {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.board-item-details-created-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 0.5rem 0;\n}\n\n.board-item-created-scrollable-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.board-item-accept-reject-section {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  gap: 12px;\n  padding: 0.75rem 1.5rem;\n  border-top: 1px solid #f0f0f0;\n  background: #fff;\n  z-index: 2;\n}\n\n.board-item-details-buttons-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.board-item-btns-1 {\n  width: 50% !important;\n  background-color: #fff !important;\n  border: 1px solid #0b0b0b !important;\n  color: #333 !important;\n}\n\n.board-item-btns-2 {\n  width: 50% !important;\n}\n\n.board-item-trips-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: #f5f5f5;\n  font-size: 0.9rem;\n}\n\n.board-item-trips-accordion {\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n\n.board-item-trip {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.board-item-trip-item {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 1rem;\n  border: 1px solid #ccc;\n  font-size: 0.8rem;\n}\n\n.board-item-trip-radio-label {\n  font-size: 0.8rem;\n}\n\n.board-item-trip-radio-label-trip-id {\n  font-weight: bold;\n}\n\n.board-item-trip-type-radio {\n  font-size: 0.8rem;\n}\n\n.soft-select__menu-portal {\n  z-index: 10001 !important;\n}\n\n.ods-table {\n  width: 100%;\n  font-size: 0.875rem;\n  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2); */\n  display: table;\n}\n\n@media screen and (max-width: 580px) {\n  .ods-table {\n    display: block;\n  }\n}\n\n.ods-table-row {\n  display: table-row;\n  background: #fff;\n}\n\n.ods-table-row:nth-of-type(odd) {\n  background: #f5f5f5;\n}\n\n.ods-table-row.header {\n  font-weight: 600;\n  /* color: #ffffff; */\n  /* background: var(--blue); */\n}\n\n@media screen and (max-width: 580px) {\n  .ods-table-row {\n    padding: 14px 0 7px;\n    display: block;\n  }\n\n  .ods-table-row.header {\n    padding: 0;\n    height: 6px;\n  }\n\n  .ods-table-row.header .ods-table-cell {\n    display: none;\n  }\n\n  .ods-table-row .ods-table-cell {\n    margin-bottom: 10px;\n  }\n\n  .ods-table-row .ods-table-cell:before {\n    margin-bottom: 3px;\n    content: attr(data-title);\n    min-width: 98px;\n    font-size: 0.625rem;\n    line-height: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n    color: #969696;\n    display: block;\n  }\n}\n\n.ods-table-cell {\n  padding: 6px 4px;\n  display: table-cell;\n}\n\n@media screen and (max-width: 580px) {\n  .ods-table-cell {\n    padding: 2px 16px;\n    display: block;\n  }\n\n  .ods-table-footer {\n    display: none;\n  }\n}\n\n.ods-table-footer {\n  padding: 6px 12px;\n  border: none !important;\n  font-weight: 700;\n  font-size: 1.125rem;\n  background-color: #f5f5f5;\n}\n\n.single-page-open-box {\n  flex: 1;\n}\n\n.ods-board-item-channel-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.688rem;\n  font-weight: 600;\n  border: 1px solid;\n  text-transform: capitalize;\n  transition: all 0.2s ease;\n}\n\n.ods-board-item-channel-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Hover effect for the badge */\n.ods-board-item-channel-badge:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.ods-board-sales-channel {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.813rem;\n  font-weight: 700;\n}\n\n.ods-board-delivery-agent {\n  font-weight: 500;\n  font-size: 0.813rem;\n  color: #6c7289;\n}\n\n.ods-board-agent-name {\n  font-weight: 700;\n  font-size: 0.813rem;\n  color: #5b6072;\n}\n\n/* ── Dark theme ── */\n.dark .board-item-accept-reject-section {\n  background: #0f172a;\n  border-top-color: #334155;\n}\n\n.dark .board-item-btns-1 {\n  background-color: #1e293b !important;\n  border-color: #475569 !important;\n  color: #f1f5f9 !important;\n}\n\n.dark .board-item-trips-container {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .board-item-trip-item {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .ods-table-row {\n  background: #1e293b;\n  color: #f1f5f9;\n}\n\n.dark .ods-table-row:nth-of-type(odd) {\n  background: #0f172a;\n}\n\n.dark .ods-table-footer {\n  background-color: #1e293b;\n  color: #f1f5f9;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
